import s from './LocationInfo.module.css';
import Button from '../Button';
import { LocationInfoEntity } from '@/types/model';
import { ImageLoader } from '@/lib/imageLoader';
import { ReactSVG } from 'react-svg';
import { hideDecorativeSvg } from '@/lib/a11y';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';

const LocationInfoimport = ({ address, icon, cta }: LocationInfoEntity) => {
  const t = useTranslations('location');

  const handleClick = () => {
    window.open(cta.action!);
  };
  return (
    <motion.div
      whileInView={{ opacity: [0, 1], transition: { duration: 1, delay: 0.2 } }}
      className={s.container}>
      <div className={s.container__pin}>
        <ReactSVG src={ImageLoader({ src: icon?.url })} beforeInjection={hideDecorativeSvg} />
      </div>
      <p className={s.container__adress}>{address}</p>
      {cta && <Button label={t('goToLocation')} onClick={handleClick} />}
    </motion.div>
  );
};

export default LocationInfoimport;
